import { TextLink } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Body, Title } from "@vds/typography";
import { TABLE_COLUMNS } from "../../global/constants/constants";
import { getFilterOptions } from "../../global/utility/deviceTableUtils";
import "./PendingUsersTab.css";
import { Tooltip } from "@mui/material";
import { sortAlphabetically, sortByFormattedDate, SORT_DIRECTIONS } from "../../global/utility/sortingUtils";

export const createPendingUsersColumns = ({
  onUserDetailsClick,
  getUserNameById,
  canDeleteUser,
  handleDelete,
  handleResendInvite,
  roleList,
  siteTagList,
  usersList
}) => {
  return [
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          {TABLE_COLUMNS.USER}
        </Title>
      ),
      dataIndex: "User",
      key: "User",
      sorter: (a, b) => sortAlphabetically(a, b, "User"),
      sortDirections: SORT_DIRECTIONS,
      render: (text, record) => {
        return (
          <TextLink
            type="standAlone"
            size="large"
            className="link pending-users-link"
            onClick={() => onUserDetailsClick && onUserDetailsClick(record)}
          >
            <Body size="large" viewport="desktop" primitive="span">
              {text}
            </Body>
          </TextLink>
        );
      },
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          {TABLE_COLUMNS.EMAIL}
        </Title>
      ),
      dataIndex: "Email",
      key: "Email",
      sorter: (a, b) => sortAlphabetically(a, b, "Email"),
      sortDirections: SORT_DIRECTIONS,
      render: (text, record) => {
        return (
          <Body size="medium" viewport="desktop" primitive="span">
            {text}
          </Body>
        );
      },
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          {TABLE_COLUMNS.DATE_INVITED}
        </Title>
      ),
      dataIndex: "DateInvited",
      key: "DateInvited",
      sorter: (a, b) => sortByFormattedDate(a, b, "DateInvited"),
      sortDirections: SORT_DIRECTIONS,
      render: (text, record) => {
        return (
          <Body size="medium" viewport="desktop" primitive="span">
            {text}
          </Body>
        );
      },
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          {TABLE_COLUMNS.ADDED_BY}
        </Title>
      ),
      dataIndex: "AddedBy",
      key: "AddedBy",
      sorter: (a, b) => {
        const addedByA = (getUserNameById(a.AddedBy) || "").toLowerCase();
        const addedByB = (getUserNameById(b.AddedBy) || "").toLowerCase();
        return addedByA < addedByB ? -1 : addedByA > addedByB ? 1 : 0;
      },
      sortDirections: SORT_DIRECTIONS,
      render: (text, record) => {
        const userName = getUserNameById(text);
        const addedByUser = usersList?.find(user => user.id === text);
        
        return addedByUser ? (
          <TextLink
            type="standAlone"
            size="large"
            className="link active-users-link"
            onClick={() => onUserDetailsClick({ ...addedByUser, isActiveUser: true })}
          >
            <Body size="medium" viewport="desktop" primitive="span">
              {userName}
            </Body>
          </TextLink>
        ) : (
          <Body size="medium" viewport="desktop" primitive="span">
            {userName}
          </Body>
        );
      },
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          {TABLE_COLUMNS.ACTIONS}
        </Title>
      ),
      dataIndex: "Actions",
      key: "Actions",
      render: (text, record) => {
        const canDelete = canDeleteUser(record.roleObj?.name); 
        
        return {
          children: (
            <div style={{ display: "flex", gap: "10px" }}>
              {canDelete && (
                <Tooltip title="Delete user">
                  <div 
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(record)}
                  >
                    <Icon name="trash" size="medium" color="#000000" ariaLabel="Delete user" ariaHidden="true"/>
                  </div>
                </Tooltip>
              )}
              <Tooltip title="Resend invite">
                <div 
                  style={{ cursor: "pointer" }}
                  onClick={() => handleResendInvite(record)}
                >
                  <Icon name="email" size="medium" color="#000000" ariaLabel="Resend invite" ariaHidden="true"/>
                </div>
              </Tooltip>
             
            </div>
          ),
        };
      },
    },
    {
      dataIndex: "role",
      key: "role",
      width: 0,
      isFilter: true,
      filter: getFilterOptions(roleList, "role"),
      onFilter: (value, record) => {
        return record.role?.id === value;
      },
      onHeaderCell: () => ({
        style: { 
          display: 'none',
          width: 0,
          padding: 0, 
          margin: 0,
          border: 'none'
        }
      }),
      onCell: () => ({
        style: { 
          display: 'none',
          width: 0,
          padding: 0, 
          margin: 0,
          border: 'none'
        }
      }),
      render: () => null
    },
    {
      dataIndex: "site",
      key: "site", 
      width: 0,
      isFilter: true,
      filter: getFilterOptions(siteTagList?.sites, "site"),
      onFilter: (value, record) => {
        if (record.siteIds && Array.isArray(record.siteIds)) {
          return record.siteIds.includes(value);
        }
        return record.site?.id === value;
      },
      onHeaderCell: () => ({
        style: { 
          display: 'none',
          width: 0,
          padding: 0, 
          margin: 0,
          border: 'none'
        }
      }),
      onCell: () => ({
        style: { 
          display: 'none',
          width: 0,
          padding: 0, 
          margin: 0,
          border: 'none'
        }
      }),
      render: () => null
    },
  ];
};